import { useEffect } from 'react';
import { useSiteSettings } from '../hooks/useSiteSettings';

// Converte HEX para HSL para usar com Tailwind
const hexToHSL = (hex) => {
  if (!hex) return null;
  
  // Remove # se existir
  hex = hex.replace('#', '');
  
  // Converte para RGB
  const r = parseInt(hex.substring(0, 2), 16) / 255;
  const g = parseInt(hex.substring(2, 4), 16) / 255;
  const b = parseInt(hex.substring(4, 6), 16) / 255;
  
  const max = Math.max(r, g, b);
  const min = Math.min(r, g, b);
  let h, s, l = (max + min) / 2;
  
  if (max === min) {
    h = s = 0;
  } else {
    const d = max - min;
    s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
    switch (max) {
      case r: h = ((g - b) / d + (g < b ? 6 : 0)) / 6; break;
      case g: h = ((b - r) / d + 2) / 6; break;
      case b: h = ((r - g) / d + 4) / 6; break;
      default: h = 0;
    }
  }
  
  return `${Math.round(h * 360)} ${Math.round(s * 100)}% ${Math.round(l * 100)}%`;
};

const DynamicTheme = () => {
  const { settings } = useSiteSettings();
  
  useEffect(() => {
    if (!settings) return;
    
    const root = document.documentElement;
    
    // Aplicar cores como variáveis CSS customizadas
    if (settings.primary_color) {
      root.style.setProperty('--theme-primary', settings.primary_color);
      const hsl = hexToHSL(settings.primary_color);
      if (hsl) root.style.setProperty('--primary', hsl);
    }
    
    if (settings.secondary_color) {
      root.style.setProperty('--theme-secondary', settings.secondary_color);
    }
    
    if (settings.accent_color) {
      root.style.setProperty('--theme-accent', settings.accent_color);
      const hsl = hexToHSL(settings.accent_color);
      if (hsl) root.style.setProperty('--accent', hsl);
    }
    
    if (settings.background_color) {
      root.style.setProperty('--theme-background', settings.background_color);
      const hsl = hexToHSL(settings.background_color);
      if (hsl) root.style.setProperty('--background', hsl);
    }
    
    if (settings.text_color) {
      root.style.setProperty('--theme-text', settings.text_color);
      const hsl = hexToHSL(settings.text_color);
      if (hsl) root.style.setProperty('--foreground', hsl);
    }
    
  }, [settings]);
  
  return null;
};

export default DynamicTheme;
